import { Box, Divider, Grid, Stack, Typography } from '@mui/material';
import { PriceBand, VacancyPrice } from 'types/vacancyStats';
import { formatRub } from 'utils/vacancyStatsFormat';
import { EmptyState, WidgetCard } from './shared';

interface Props {
  price: VacancyPrice;
}

const REGIONS: { key: keyof Pick<VacancyPrice, 'moscow' | 'saintPetersburg' | 'regions'>; label: string }[] = [
  { key: 'moscow', label: 'Москва' },
  { key: 'saintPetersburg', label: 'Санкт-Петербург' },
  { key: 'regions', label: 'Регионы' }
];

const PriceRow = ({ label, value, emphasis = false }: { label: string; value: string; emphasis?: boolean }) => (
  <Stack direction="row" alignItems="baseline" justifyContent="space-between">
    <Typography variant="caption" sx={{ color: 'text.disabled', fontWeight: 700 }}>
      {label}
    </Typography>
    <Typography
      variant={emphasis ? 'subtitle1' : 'body2'}
      sx={{ fontWeight: emphasis ? 700 : 600, color: emphasis ? 'grey.900' : 'text.primary' }}
    >
      {value}
    </Typography>
  </Stack>
);

const RegionCard = ({ label, band }: { label: string; band: PriceBand }) => (
  <Box
    sx={{
      p: 2.5,
      height: '100%',
      borderRadius: 2,
      bgcolor: 'grey.100',
      border: '1px solid',
      borderColor: 'grey.300'
    }}
  >
    <Typography
      variant="caption"
      sx={{
        display: 'block',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        fontWeight: 700,
        color: 'text.disabled',
        mb: 1.5
      }}
    >
      {label}
    </Typography>
    <Stack spacing={1} divider={<Divider flexItem />}>
      <PriceRow label="Минимум" value={formatRub(band.min)} />
      <PriceRow label="Медиана" value={formatRub(band.median)} emphasis />
      <PriceRow label="Максимум" value={formatRub(band.max)} />
    </Stack>
  </Box>
);

const PriceWidget = ({ price }: Props) => {
  const { evaluated, ofTotal } = price;

  return (
    <WidgetCard
      overline="Зарплаты"
      title="Зарплатные ожидания"
      coverage={{ evaluated, ofTotal }}
    >
      {evaluated === 0 ? (
        <EmptyState icon="mdi:cash-multiple" />
      ) : (
        <Grid container spacing={2}>
          {REGIONS.map(({ key, label }) => (
            <Grid item xs={12} sm={4} key={key}>
              <RegionCard label={label} band={price[key]} />
            </Grid>
          ))}
        </Grid>
      )}
    </WidgetCard>
  );
};

export default PriceWidget;
